import { createContext, use } from 'react';

import type { EntityTableFilterParams } from '@/components/map/utils/entityMapFilters';

export interface StatsFiltersContextValue {
    /** Serialised committed map filters, or null when filters are inactive. */
    filters: EntityTableFilterParams | null;
    /** Stable string form of `filters` for cache keys ('none' when inactive). */
    filtersKey: string;
    setFilters: (next: EntityTableFilterParams | null) => void;
}

/**
 * Default is the inert no-filter state so consumers outside the Find & Fix layout
 * (SAVI, tests) behave exactly as before: stats fetch unfiltered.
 */
export const StatsFiltersContext = createContext<StatsFiltersContextValue>({
    filters: null,
    filtersKey: 'none',
    setFilters: () => {},
});

export function useStatsFilters(): StatsFiltersContextValue {
    return use(StatsFiltersContext);
}

export function statsFiltersKey(filters: EntityTableFilterParams | null): string {
    return filters === null ? 'none' : JSON.stringify(filters);
}
